import Chart from 'chart.js';

var chart = function (t) {
    t(document).ready(function () {
        var e = t("#district-chart");
        var backGroundColor = "#00ab6c";
        var mainTitle = e.data("title")  || "Historical Value Growth";
        if (e.length) {
            e[0].getContext("2d");

            const chartData = e.data('chart-data');

            var a = chartData.map((data) => data.amount);
            var n = chartData.map((data) => data.year);
            var min = chartData[0].amount;
            var max = chartData[0].amount;

            chartData.forEach(data => min = Math.min(min, data.amount));
            chartData.forEach(data => max = Math.max(max, data.amount));

            max = (Math.ceil(max / 100) * 100) +200;

            min = (Math.floor(min / 100) * 100) > 200 ? (Math.floor(min / 100) * 100) - 100 : (Math.floor(min / 100) * 100);

            Chart.defaults.global.defaultFontSize = 16,
                Chart.defaults.global.defaultFontFamily = "circularstd_book",
                Chart.defaults.global.defaultFontColor = "#a9a9a9";
            var s = {
                labels: n,
                datasets: [{
                    data: a,
                    borderColor: backGroundColor,
                    borderWidth: 5,
                    fill: !1,
                    lineTension: 0,
                    pointBackgroundColor:backGroundColor,
                    pointBorderColor: "#ffffff",
                    pointBorderWidth: 3,
                    pointRadius: 7,
                    pointStyle: "rect",
                    pointHoverBorderWidth: 3,
                    pointHoverRadius: 7
                }]
            }
                , i = {
                layout: {
                    padding: {
                        top: 10,
                        right: 10,
                        bottom: 10,
                        left: 10
                    }
                },
                legend: {
                    display: !1
                },
                title: {
                    display: !0,
                    text: mainTitle,
                    fontSize: 24,
                    fontColor: "#000000",
                    fontFamily: "circularstd_black",
                    fontStyle: "normal"
                },
                tooltips: {
                    backgroundColor: "#f2f2f2",
                    titleFontSize: 0,
                    titleMarginBottom: 0,
                    bodyFontFamily: "circularstd_book",
                    bodyFontSize: 24,
                    bodyFontColor: backGroundColor,
                    xPadding: 20,
                    yPadding: 20,
                    cornerRadius: 0,
                    displayColors: !1,
                    callbacks: {
                        label: function (t, e) {
                            return t.yLabel + " K"
                        }
                    }
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            display: !1
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            suggestedMin: min,
                            suggestedMax: max,
                            stepSize: 100,
                            callback: function (t, e, a) {
                                return t + " K"
                            }
                        }
                    }]
                }
            };
            new Chart(e, {
                type: "line",
                data: s,
                options: i
            })
        }
    })
}(jQuery);
